console.log('country-popup.js geladen');
console.log('Vollständiges meta-Objekt:', JSON.stringify(meta, null, 2));

// Funktion zum Abrufen der Länderdaten
async function getCountryData() {
  try {
    const response = await fetch('https://shop.edelschwarz.it/browsing_context_suggestions.json');
    const data = await response.json();
    console.log('Länderdaten erhalten:', data);
    return data.detected_values.country.handle;
  } catch (error) {
    console.error('Fehler beim Abrufen der Länderdaten:', error);
    return null;
  }
}

// Funktion zum Anzeigen des Popups für Österreich
function showPopupAT() {
  console.log('Zeige AT Popup');
  const modalHTML = `
    <div class="modal micromodal-slide" id="country-modal-at" aria-hidden="true">
      <div class="modal__overlay" tabindex="-1" data-micromodal-close>
        <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="country-modal-at-title">
          <header class="modal__header">
            <h2 class="modal__title" id="country-modal-at-title">
              Hinweis für österreichische Kunden
            </h2>
            <button class="modal__close" aria-label="Close modal" data-micromodal-close></button>
          </header>
          <main class="modal__content2" id="country-modal-at-content">
            <p>In Österreich sind alle Herbert Pixner Produkte nur direkt über Herbert Pixner erhältlich.</p>
          </main>
          <footer class="modal__footer">
            <a href="https://www.herbert-pixner.com/shop/" target="_blank" class="modal__btn">SHOP Herbert Pixner</a>
            <button class="modal__btn" data-micromodal-close aria-label="Close this dialog window">Schließen</button>
          </footer>
        </div>
      </div>
    </div>
  `;
  document.body.insertAdjacentHTML('beforeend', modalHTML);
  MicroModal.show('country-modal-at');
}

// Funktion zum Anzeigen des Popups für Deutschland
function showPopupDE() {
  console.log('Zeige DE Popup');
  const modalHTML = `
    <div class="modal micromodal-slide" id="country-modal-de" aria-hidden="true">
      <div class="modal__overlay" tabindex="-1" data-micromodal-close>
        <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="country-modal-de-title">
          <header class="modal__header">
            <h2 class="modal__title" id="country-modal-de-title">
              Hinweis für deutsche Kunden
            </h2>
            <button class="modal__close" aria-label="Close modal" data-micromodal-close></button>
          </header>
          <main class="modal__content2" id="country-modal-de-content">
            <p>In Deutschland sind die Produkte Flachmann „Lörget Gin" – Herbert Pixner Edition sowie Herbert Pixner's „Vino Rosso & Vino Bianco" nur direkt über Herbert Pixner erhältlich.</p>
          </main>
          <footer class="modal__footer">
            <a href="https://www.herbert-pixner.com/shop/" target="_blank" class="modal__btn">SHOP Herbert Pixner</a>
            <button class="modal__btn" data-micromodal-close aria-label="Close this dialog window">Schließen</button>
          </footer>
        </div>
      </div>
    </div>
  `;
  document.body.insertAdjacentHTML('beforeend', modalHTML);
  MicroModal.show('country-modal-de');
}

// Funktion zur Überprüfung, ob das aktuelle Produkt das Popup anzeigen soll
function shouldShowPopup(countryHandle) {
  console.log('Prüfe shouldShowPopup für Land:', countryHandle);
  console.log('Meta:', meta);
  const productId = meta.product ? meta.product.id.toString() : '';
  console.log('Aktuelle Produkt-ID:', productId);
  
  if (countryHandle === 'AT') {
    const allowedProductIds = ['10085016666443', '10085017256267', '10108885696843'];
    const allowedCollectionId = '629240594763';
    
    if (allowedProductIds.includes(productId)) {
      console.log('Produkt-ID ist in der erlaubten Liste');
      return true;
    }
    
    console.log('Prüfe Collection:', meta.page);
    if (meta.page && meta.page.resourceType === 'collection') {
      console.log('Seite ist eine Collection');
      console.log('Collection ID:', meta.page.resourceId);
      console.log('Erlaubte Collection ID:', allowedCollectionId);
      if (String(meta.page.resourceId) === String(allowedCollectionId)) {
        console.log('Collection-ID stimmt überein');
        return true;
      }
    }
  } 
  else if (countryHandle === 'DE') {
    const allowedProductIds = ['10150659096907', '10150675382603', '10085017256267', '10108885696843'];
    return allowedProductIds.includes(productId);
  }
  
  console.log('Keine Übereinstimmung gefunden');
  return false;
}

// Hauptfunktion
async function checkCountryAndShowPopup() {
  console.log('checkCountryAndShowPopup aufgerufen');
  const countryHandle = await getCountryData();
  console.log('Ländercode:', countryHandle);
  if (shouldShowPopup(countryHandle)) {
    console.log('Popup sollte angezeigt werden');
    if (countryHandle === 'AT') {
      showPopupAT();
    } else if (countryHandle === 'DE') {
      showPopupDE();
    }
  } else {
    console.log('Popup sollte nicht angezeigt werden');
  }
}

// Warten Sie, bis das Dokument geladen ist, bevor Sie MicroModal initialisieren und die Hauptfunktion aufrufen
document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM geladen, initialisiere MicroModal');
  // Initialisieren Sie MicroModal
  MicroModal.init();

  console.log('Rufe checkCountryAndShowPopup auf');
  // Führen Sie die Hauptfunktion aus
  checkCountryAndShowPopup();
});